'use strict';

var extend = require('extend');

var notes = require('notes-frequencies-map');

module.exports = function (str, rest) {
  if (typeof str !== 'string') {
    throw new TypeError('Expected a string');
  }

  rest = extend({
    enable: false,
    value: null,
    duration: 0.125
  }, rest);
  str = str.toUpperCase();
  str = str.replace(/\|\s*/g, '');
  str = str.replace(/♯/g, '#');
  str = str.split(' ');
  var output = [];
  var note;
  var duration;

  for (var i = 0; i < str.length; i++) {
    if (/R($|@[0-9]+\/?[0-9]*)/.test(str[i])) {
      note = rest.value;
    } else {
      note = str[i].match(/([A-Z](#|♭)?[0-9])/);

      if (note === null || notes[note[0]] === undefined) {
        throw new Error(str[i] + ' is not a valid note');
      }

      note = notes[note[0]];
    }

    duration = str[i].match(/@([0-9]+\.?[0-9]*\/?[0-9]*)/);

    if (duration === null) {
      duration = 1;
    } else {
      duration = duration[1];

      if (/\/[0-9]+/.test(duration)) {
        duration = duration.match(/([0-9]+\.?[0-9]*)/g);
        duration = duration[0] / duration[1];
      } else {
        duration = parseFloat(duration);
      }
    }

    output.push([note, duration]);

    if (rest.enable) {
      output.push([rest.value, rest.duration]);
    }
  }

  return output;
};